function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil1{fill:#fffffe;fill-rule:nonzero}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "fil1",
  d: "M1.013 3.694a.761.761 0 0 1-.155-.475c0-.189.078-.361.203-.487a.688.688 0 0 1 .487-.203h.686a3.175 3.175 0 0 0-.042-.084 1.464 1.464 0 0 1-.135-.331 1.252 1.252 0 0 1 0-.597.681.681 0 0 1 .272-.42.844.844 0 0 1 .483-.125c.167 0 .272.124.34.276.056.125.085.27.102.362v.003l.001.003.005.02c.029.138.066.31.154.398.125.125.238.269.351.413.086.11.172.22.266.323.052.057.197.1.335.141.221.066.43.128.43.305v1.948a.295.295 0 0 1-.088.21.314.314 0 0 1-.21.09v.001H4.49a5.381 5.381 0 0 0-.48.06 2.833 2.833 0 0 0-.374.083 4.91 4.91 0 0 1-.737.2 4.545 4.545 0 0 1-.782.046 1.092 1.092 0 0 1-.38-.07.715.715 0 0 1-.435-.488.973.973 0 0 1-.03-.295.768.768 0 0 1-.17-.66.729.729 0 0 1-.117-.31.838.838 0 0 1 .028-.337zm.093-.268a.56.56 0 0 0 .1.17c.029.027.04.07.026.11a.658.658 0 0 0-.036.298.526.526 0 0 0 .103.247.107.107 0 0 1 .02.1.543.543 0 0 0-.003.288.516.516 0 0 0 .133.24c.026.021.041.054.038.09a.798.798 0 0 0 .02.272.505.505 0 0 0 .309.345.88.88 0 0 0 .313.055c.325 0 .534-.009.735-.042.2-.034.4-.093.705-.194.1-.032.253-.064.407-.09a5.602 5.602 0 0 1 .514-.063.1.1 0 0 0 .068-.029.083.083 0 0 0 .024-.059V3.216c0-.018-.134-.058-.277-.1-.166-.05-.34-.102-.431-.203a5.944 5.944 0 0 1-.276-.335 4.362 4.362 0 0 0-.334-.393c-.134-.133-.178-.34-.213-.505l-.004-.02a.108.108 0 0 1-.002-.009l.105-.019-.105.019a1.44 1.44 0 0 0-.088-.317c-.036-.082-.084-.149-.145-.149a.643.643 0 0 0-.364.088.477.477 0 0 0-.185.296 1.006 1.006 0 0 0 0 .493c.029.111.074.2.118.285.042.08.082.158.11.252a.106.106 0 0 1-.101.143h-.842a.476.476 0 0 0-.477.477c0 .075.012.144.035.207zM5.009 2.892h.853c.06 0 .107.048.107.107v2.56a.107.107 0 0 1-.107.106H5.01a.107.107 0 0 1-.107-.106v-2.56c0-.06.048-.107.107-.107zm.747.213h-.64v2.347h.64V3.105z"
});

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 655.359,
    height: 655.359,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 6.827 6.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h6.827v6.827H0z"
  }), _ref3, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h6.827v6.827H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.fe44c1ea.svg";
export { ForwardRef as ReactComponent };